export const config = () => {
  let BASE_URL: string | any;
  BASE_URL = "https://www.casawalkin.com/api";
  // BASE_URL = "http://localhost:8081/api";
  let SALESFORCE_ONGOING_PROJECTS_URL: string =
    process.env.REACT_APP_SALESFORCE_ONGOING_PROJECTS_URL ||
    'https://casagrandbuilderprivatelimited.my.salesforce-sites.com/channelpartnersv/services/apexrest/ongoingProjects';
  return {
    BASE_URL,
    SALESFORCE_ONGOING_PROJECTS_URL,
  };
};
